import * as actions from "../actions/Type";
import primary_logo from "../assets/images/i_1.png";
import logo from "../assets/images/i_1.png";
import footer_logo from "../assets/images/i_2.png";
import primary_logo_bill from "../assets/images/i_1.png";
import footer_logo_bill from "../assets/images/i_2.png";
const intialState = {
  lang: "krd",
  primarycolor: "#000",
  secondarycolor: "#000",
  thirdcolor: "#000",
  primary_logo: primary_logo,
  footer_logo: footer_logo,
  logo_print_list: primary_logo,
  logo: logo,
  primary_logo_bill,
  footer_logo_bill,
  name_en: "IDRES ALI QADER RealEstate Company",
  name_arb: "شرکة عقارات ادریس علی قادر",
  name_krd: "کۆمپانیای عقارات ادریس علی قادر",
};
const HelperReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.CHANGE_LANGE_KURDISH:
      return {
        ...state,
        lang: action.payload,
      };
    case actions.CHANGE_LANGE_ENGLISH:
      return {
        ...state,
        lang: action.payload,
      };
    case actions.CHANGE_LANGE_ARABIC:
      return {
        ...state,
        lang: action.payload,
      };
    default:
      return { ...state };
  }
};

export default HelperReducer;
